import React from "react"
import styled from "styled-components"
import ToggleSwitch from "../../ui/ToggleSwitch"
import { useDispatch, useSelector } from "react-redux"
import { selectAdvancedMode, setAdvancedMode } from "./slice"
import PropTypes from "prop-types"

const Container = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 0.5rem;
`

const Text = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  padding-top: 0.3rem;
`

const SwitchContainer = styled.div`
  transform: scale(0.7);
`

// A smart component to set advanced mode in app state
// Advanced mode provides additional technical information to the user which may otherwise clutter the page.
// TODO it would be nice to show a message if the user tries to click on the Toggle and its disabled due to an override
const AdvancedModeToggle = ({ override = false }) => {
  const dispatch = useDispatch()

  const advancedMode = useSelector(selectAdvancedMode)
  const handleAdvancedModeChange = (checked) => {
    dispatch(setAdvancedMode(checked))
  }
  return (
    <Container title="Expert mode displays additional data, and timestamps in UTC">
      <SwitchContainer>
        <ToggleSwitch
          handleChange={handleAdvancedModeChange}
          checked={override ? override : advancedMode}
          id="mode"
          disabled={override}
        />
      </SwitchContainer>
      <Text>Expert mode</Text>
    </Container>
  )
}

AdvancedModeToggle.propTypes = {
  // The component looks up advanced mode from redux state.  There are times when we want to override this
  // For example when there is a filter on one columns only visible in advanced mode.
  // The value of override will be set in advancedMode
  override: PropTypes.bool,
}

export default AdvancedModeToggle
